<template>
  <div>
    <h3>Active Opportunities</h3>
    <opportunities-list
      v-on:term-change="changeTerm"
      :opportunities="opportunities"
      :terms="terms"
      :term="term"
      :types="types"
    ></opportunities-list>
  </div>
</template>

<script>
import OpportunitiesList from "../../components/opportunities/opportunities-list";
import opportunitiesApi from "../../api/opportunity";
import termsApi from "../../api/terms";

export default {
  data() {
    return {
      opportunities: [],
      terms: [],
      types: [],
      term: null,
      type: null,
    };
  },

  components: {
    "opportunities-list": OpportunitiesList,
  },
  methods: {
    changeTerm(term) {
      this.getOpportunities(term);
    },
    getOpportunities(term) {
      opportunitiesApi
        .getOpportunities(term)
        .then((response) => {
          this.opportunities = response.data;
        })
        .catch(function (error) {
          console.log(error);
        });
    },
  },
  watch: {
    terms: function () {
      if (this.term === null) {
        //this.term = this.terms[0].termId;
        var foundTerm = _.find(this.terms, (t) => {
          var start = new Date(t.termStart);
          var end = new Date(t.termEnd);
          return start.getTime() <= Date.now() && end.getTime() >= Date.now();
        });
        if (foundTerm) {
          this.term = foundTerm.termId;
        }
      }
    },
    term: function (value) {
      if (value) {
        this.getOpportunities(value);
      }
    },
  },
  created() {
    var that = this;
    if (this.term) {
      this.getOpportunities(this.term);
    }

    opportunitiesApi.getOpportunityTypes().then((response) => {
      that.types = response.data;
    });

    termsApi.getTerms().then((response) => {
      this.terms = response.data;
    });
  },
};
</script>

<style scoped>
</style>
